export function registerGameServiceWorker(): void {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) {
    return;
  }

  window.addEventListener('load', () => {
    const serviceWorkerUrl = new URL('./sw.js', document.baseURI);
    void navigator.serviceWorker
      .register(serviceWorkerUrl, { scope: './' })
      .then((registration) => {
        registration.addEventListener('updatefound', () => {
          const candidate = registration.installing;
          candidate?.addEventListener('statechange', () => {
            if (candidate.state === 'installed' && navigator.serviceWorker.controller) {
              window.dispatchEvent(new CustomEvent('brick-rogue:update-ready'));
            }
          });
        });
      })
      .catch((error: unknown) => {
        window.dispatchEvent(
          new CustomEvent('brick-rogue:service-worker-error', { detail: error }),
        );
      });
  });
}

export async function activateWaitingServiceWorker(): Promise<void> {
  if (!('serviceWorker' in navigator)) {
    window.location.reload();
    return;
  }
  const registration = await navigator.serviceWorker.getRegistration();
  if (!registration?.waiting) {
    window.location.reload();
    return;
  }
  navigator.serviceWorker.addEventListener('controllerchange', () => window.location.reload(), {
    once: true,
  });
  registration.waiting.postMessage({ type: 'SKIP_WAITING' });
}
